import styled from "styled-components";
import LogoImg from "../../assets/images/logo/logo.png";
const Wrapper = styled.div``;
function LogoFull({ height }) {
  return (
    <Wrapper>
      <img src={LogoImg} alt="Logo" height={height || "50px"} />
    </Wrapper>
  );
}

export default LogoFull;
